module.exports = __webpack_public_path__ + "img/logo-pbb-white.9462a27c.png";